import { render, staticRenderFns } from "./XmCarousel.vue?vue&type=template&id=3977f7fe&scoped=true"
import script from "./XmCarousel.vue?vue&type=script&lang=js"
export * from "./XmCarousel.vue?vue&type=script&lang=js"
import style0 from "./XmCarousel.vue?vue&type=style&index=0&id=3977f7fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3977f7fe",
  null
  
)

export default component.exports